import { render } from "./new-branch.vue?vue&type=template&id=526e53c5"
import script from "./new-branch.vue?vue&type=script&lang=js"
export * from "./new-branch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__